import { type Zone, type ParkingAssistantSettings } from 'src/api/fm/zones/zones.model'
import { type ParkingPhotoSettings } from 'src/api/fm/tasks/tasks.model'

export const SET_ZONE_OPTIONS = 'SET_ZONE_OPTIONS' as const
export const SET_ALL_ZONES = 'SET_ALL_ZONES' as const
export const FETCH_ALL_ZONES = 'FETCH_ALL_ZONES' as const
export const GET_ZONE_PARKING_ASSISTANT_SETTINGS = 'GET_ZONE_PARKING_ASSISTANT_SETTINGS' as const
export const SET_ZONE_PARKING_ASSISTANT_SETTINGS = 'SET_ZONE_PARKING_ASSISTANT_SETTINGS' as const
export const UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS = 'UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS' as const
export const GET_PARKING_PHOTO_SETTINGS = 'GET_PARKING_PHOTO_SETTINGS' as const
export const GET_PARKING_PHOTO_SETTINGS_SUCCESS = 'GET_PARKING_PHOTO_SETTINGS_SUCCESS' as const
export const EDIT_PARKING_PHOTO_SETTINGS = 'EDIT_PARKING_PHOTO_SETTINGS' as const

export interface ZoneOption {
    value: string
    label: string
    currency: string
}

export interface ZoneStringOption {
    value: string
    label: string
}

export interface ZoneState {
    zoneOptions: ZoneOption[]
    allZones: Zone[]
    zoneParkingAssistantSettings: ParkingAssistantSettings | null
    parkingPhotoSettings: ParkingPhotoSettings
}
